import React from 'react';
import { Grid, Icon, Button } from '@material-ui/core';
import { Loader } from '../../elements';
import { LoaderSize } from '../../constants/constants';
import { useTranslation } from 'react-i18next';
import useAuthContext from '../../hooks/useAuthContext';
import { useStyles } from './styles';
import UserRole from '../../constants/user-role';

const OccupationCalendarManager = () => {
  const classes = useStyles();
  const { state } = useAuthContext();
  const { t } = useTranslation();

  const [isBusy, setIsBusy] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    if (loaded === false) {
      const doLoadAction = async () => {};

      setIsBusy(true);

      doLoadAction().finally(() => {
        setIsBusy(false);
        setLoaded(true);
      });
    }
  }, [loaded]);

  const hasPermission = () => {
    return state.role !== UserRole.user;
  };

  return (
    <Grid container>
      <Grid container direction="row" className={classes.paperHeader}>
        <Grid item container md={6} xs={10} spacing={1}></Grid>

        <Grid item container md={6} xs={10} className={classes.justifyRight}>
          <Grid item>
            {hasPermission() && (
              <Button
                onClick={() => {}}
                id="saveButton"
                className={classes.withMarginLeft}
                disabled={true}
                startIcon={<Icon>{'save'}</Icon>}
                variant="contained"
                size="small"
                color="inherit"
              >
                {t('f-save')}
              </Button>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Loader isLoading={isBusy} size={LoaderSize.DEFAULT_SIZE} />

      {loaded && (
        <Grid container spacing={3}>
          <Grid item></Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default OccupationCalendarManager;
